import React from 'react'
import { Flex, Box } from 'grid-styled'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import {
  renderSelectField,
  renderAgencyInput,
  renderAccountInput,
  renderAccountDigitInput
} from '../../../utils/renderInputs'
import { required } from '../../../utils/validators'
const { labels } = require('./data.json')

function handleChange(value) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'event',
    eventCategory: 'veloe:area-logado:dados-plano',
    eventAction: 'interacao:campo:debito',
    eventLabel: `preencheu:[[${value}]]`
  })
}

const DebitPaymentForm = ({ banks, blockFields, disableAgencyInput, onChangeBank, ...props }) => (
  <div>
    <Box mb={[24, 28]} width={[1, 380]}>
      <Field
        component={renderSelectField}
        label={labels.bank}
        onChange={() => handleChange('banco')}
        placeholder={labels.placeholder.bank}
        name="bankCode"
        options={banks}
        validate={required}
        disabled={blockFields}
        onSelected={onChangeBank}
      />
    </Box>
    <Flex direction={['column', 'row']} width={[1, 380]}>
      <Box mb={[17, 20]} mr={33} width={1}>
        <Field
          component={renderAgencyInput}
          label={labels.agency}
          onFocus={() => handleChange('agencia')}
          name="agency"
          maxlength={4}
          placeholder={labels.placeholder.agency}
          validate={required}
          disabled={disableAgencyInput}
          agencyRefFn={props.agencyRefFn}
          limitDigit={4}
        />
      </Box>
      <Box mb={[17, 20]} mr={33} width={1}>
        <Field
          component={renderAccountInput}
          label={labels.account}
          onFocus={() => handleChange('conta-corrente')}
          name="account"
          maxlength={7}
          placeholder={labels.placeholder.account}
          validate={required}
          accountRefFn={props.accountRefFn}
        />
      </Box>
      <Box mb={[17, 20]} width={1}>
        <Field
          component={renderAccountDigitInput}
          label={labels.accountDigit}
          onFocus={() => handleChange('digito')}
          maxlength={1}
          name="accountDigit"
          placeholder={labels.placeholder.accountDigit}
          validate={required}
          limitDigit={1}
        />
      </Box>
    </Flex>
  </div>
)

const mapStateToProps = ({ reducer }) => ({
  banks: reducer.banks
})

export default connect(mapStateToProps, null)(DebitPaymentForm)
